/**
 * Created by liubin on 17-3-1.
 * 存放翻译文件
 */
module.exports = {
  cn: {
    register_title: '万店掌',
    register: '注册',
    addhasgroup: '加入已有企业',
    registernewgroup_title: '企业申请使用',
    registernewgroup_title1: '企业',
    registernewgroup_title2: '申请使用',
    addhasgroup_title: '欢迎加入已有企业',
    username: '请设置用户名……',
    password: '请设置密码……',
    showname: '请输入您的姓名……',
    email: '邮箱',
    mobilephone: '请输入手机号……',
    validatecode: '请输入验证码……',
    getvalidatecode: '获取验证码',
    wait: '等待',
    second: '秒',
    groupname: '请输入企业名称……',
    createenterprise: '提交申请',
    invationcode: '请输入企业邀请码……',
    next: '下一步',
    crateenterpriseaccount: '创建企业帐号',
    inputusername: '请输入用户名',
    inputpassword: '请输入密码',
    passwordcannotsoeasy: '哦吆,密码不能这么随便',
    passwordatleastsix: '密码至少为8位数字和大小写字母组合',
    passwordmax:'密码最多50位',
    passordneednumandabc: '密码只能是数字和字母',
    inputshowname: '请输入姓名',
    inputmobilephone: '请输入手机号码',
    inputemail: '请输入邮箱',
    mobilephonenotvalid: '手机号码不符合格式',
    emailnotvalid: '邮箱不符合格式',
    inputvalidatecode: '请输入验证码',
    inputenterprisename: '请输入企业名称',
    creatingwait: '正在创建,请稍候……',
    infoperfect: '信息不完善',
    usernamehasexisted: '用户名已存在',
    mobilephonehasexisted: '手机号码已存在',
    enterprisenamehasexisted: '企业名已经存在',
    validatecodeerror: '验证码错误',
    registerfailed: '啊噢,注册失败!',
    serverexception: '服务器出现异常',
    can: '此用户名可以注册',
    cannot: '此用户名已被注册',
    validatecodesendsuccess: '验证码发送成功',
    mobilephonehasregisted: '该手机号码已被注册过',
    validatecodesendfailed: '验证码发送失败',
    inputinvationcode: '请输入邀请码',
    invationcodeerror: '邀请码错误',
    netspaceopen: '请点击右上角在浏览器中打开',
    enterprisename: '企业名：',
    invitationuser: '推荐人：',
    joingroup: '加入企业',
    createnewgroup: '创建新企业',
    beacuse: '由于',
    passfailed: ',导致审核失败',
    beacusesome: '由于某些原因,导致审核失败',
    enterprisecannotnull: '企业不能为空',
    joingroupingwait: '正在加入企业,请稍候……',
    congratulations: '恭喜您,加入企业成功！',
    joingroupfailed: '啊噢,加入企业失败！',
    uploadcertificate: '请上传企业营业执照',
    passingwait: '您的企业营业执照正在审核中，请耐心等待',
    call400: '如需紧急处理，请拨打400-666-3626',
    reuploadcertificate: '您的企业营业执照审核不通过，请重新上传',
    call4001: '如有任何疑问，请拨打400-666-3626',
    certificate: '请上传营业执照',
    support: '支持',
    upload: '上传',
    changeotheraccount: '返回',
    picnotbigthan5m: '图片大小不能超过5M',
    uploadcannotmorethan: '上传的图片最多不能超过',
    zhang: '张',
    duozhang: '多张:',
    compressfailed: '压缩失败...',
    compresscomplete: '压缩完成...',
    browsernotsupport: '浏览器不支持',
    deletecertificatesuccess: '删除企业营业执照成功',
    deletecertificatefailed: '删除企业营业执照失败',
    nonewpicupload: '没有新的图片需要上传',
    uploadingwait: '正在上传请稍候……',
    uploadcertificatesuccess: '上传营业执照成功',
    uploadcertificatefailed: '上传营业执照失败',
    notsupport: '暂不支持',
    c: '图片验证码',
    imgcodeerror: '请输入4位的图片验证码',
    inputimgcodeerror: '图片验证码错误',
    jointip: '注：企业邀请码向您的企业总部或加盟品牌总部索要',
    jointip2: '查看谁是我们企业管理员?',
    calltip: '请直接致电查询',
    method1: '方法一',
    method2: '方法二',
    method2tip:
      '留下您的手机号码和姓名信息，我们会尽快通知企业管理员与您联系。',
    submit: '提交',
    submitsuccess: '提交成功',
    submitfailed: '提交失败',
    doing: '正在处理...',
    newgroup: '新企业',
    hasgroup: '已有企业',
    join: '加入',
    nochina: '用户名不能包含中文',
    validatecodesendLimit: '今日发送验证码数量超出限制',
    experience: "体验",
    prodemo: "Demo",
    weak: '弱',
    middle: '中',
    high: '强',
    pwderrortip:'密码存在连续字母或数字（3位及以上）',
    pwdTip: '密码至少为8位大小写字母和数字组合',
    file_support: '支持png、jpg、jpeg',
    prev_step: '上一步',
    createSucces_tip1: '企业申请成功',
    createSucces_tip2: '请耐心等待与您联系',
    createSucces_tip3: '退出',
  },
  en: {
    register_title: 'Opretail',
    register: 'Resister',
    registernewgroup_title: 'Enterprise apply for use',
    registernewgroup_title1: 'Enterprise',
    registernewgroup_title2: 'Apply for use',
    addhasgroup: 'Join a company',
    username: 'User name',
    password: 'Password',
    showname: 'Display name',
    email: 'Email',
    mobilephone: 'Mobile',
    validatecode: 'Verification code',
    getvalidatecode: 'Get',
    wait: 'Wait',
    second: 's',
    groupname: 'Company',
    createenterprise: 'Add',
    invationcode: 'Invitation code',
    next: 'Next',
    crateenterpriseaccount: 'Add a company account.',
    inputusername: 'Please input username.',
    inputpassword: 'Please input password.',
    passwordcannotsoeasy: 'The password is too simple.',
    passwordatleastsix: 'Passwords should be at least 8 digits and uppercase and lowercase letters.',
    passwordmax:'密码最多50位',
    passordneednumandabc: 'Your passwords must be numbers and/or letters.',
    inputshowname: 'Please input display name.',
    inputmobilephone: 'Please input mobile.',
    inputemail: 'Please input email.',
    mobilephonenotvalid: 'Wrong mobile format',
    emailnotvalid: 'Mailbox does not conform to format',
    inputvalidatecode: 'Please input verification code.',
    inputenterprisename: 'Please input company name.',
    creatingwait: 'Adding, please wait. ',
    infoperfect: 'Incomplete information',
    usernamehasexisted: 'Same name exists.',
    mobilephonehasexisted: 'Same mobile exists.',
    enterprisenamehasexisted: 'Same company exists.',
    validatecodeerror: 'Wrong code.',
    registerfailed: 'Oops, failed to register.',
    serverexception: 'Server Error',
    can: 'Username can be registered.',
    cannot: 'Username has already been taken.',
    validatecodesendsuccess: 'Verification code has been sent.',
    mobilephonehasregisted: 'This phone number has been taken.',
    validatecodesendfailed: 'Failed to send',
    inputinvationcode: 'Please input invitation code.',
    invationcodeerror: 'Wrong invitaiton code',
    netspaceopen:
      'Please click the top-right corner to open it with a browser.',
    enterprisename: 'Company name:',
    invitationuser: 'Who refers:',
    joingroup: 'Join',
    createnewgroup: 'Add a new company',
    beacuse: 'Because',
    passfailed: ',It hasnot been approved.',
    beacusesome: 'It hasnot been approved for some reasons.',
    enterprisecannotnull: 'The company cannot be null.',
    joingroupingwait: 'Joining, please wait……',
    congratulations: 'Congratulations, you have joined this company.',
    joingroupfailed: 'Oops, failed to join this company.',
    uploadcertificate: 'Please upload the business license.',
    passingwait: 'Auditing your business license, please wait.',
    call400: 'For any emergency, please call 400-666-3626.',
    reuploadcertificate:
      'Your business license hasnot been approved. Please upload again.',
    call4001: 'For any question, please call 400-666-3626.',
    certificate: 'Business license',
    support: 'Support',
    upload: 'Upload',
    changeotheraccount: 'Back',
    picnotbigthan5m: 'Photos should be less than 5 MB.',
    uploadcannotmorethan: 'Max. uploaded pictures should be',
    zhang: 'pc',
    duozhang: 'pcs:',
    compressfailed: 'Failed to compress',
    compresscomplete: 'Compressed',
    browsernotsupport: 'Your browser is not supported.',
    deletecertificatesuccess: 'Deleted',
    deletecertificatefailed: 'Failed to delete',
    nonewpicupload: 'No photos need uploading.',
    uploadingwait: 'Uploading, please wait……',
    uploadcertificatesuccess: 'Uploaded',
    uploadcertificatefailed: 'Failed to upload',
    notsupport: 'Not yet supported',
    imgcode: 'Picture security code',
    imgcodeerror: 'Please input the security code.',
    inputimgcodeerror: 'Wrong security code',
    jointip: 'Tips: You can get the invitation code from your admin.',
    jointip2: 'Who is the Admin?',
    calltip: 'Please call the hotline to search.',
    method1: ' Method 1',
    method2: 'Method 2',
    method2tip:
      'Please leave your name and number. We will inform Admin to get right back to you.',
    submit: 'Done',
    submitsuccess: 'Submitted',
    submitfailed: 'Failed to submit',
    doing: 'Processing...',
    newgroup: 'New company',
    hasgroup: 'Existing company',
    join: 'Join',
    nochina: 'Username cannot contain Chinese',
    validatecodesendLimit: 'The number of captcha sent today has exceeded the limit.',
    experience: "Experience",
    prodemo: "Product Demo",
    weak: 'Weak',
    middle: 'Medium',
    high: 'Strong',
    pwderrortip:'密码存在连续字母或数字（3位及以上）',
    pwdTip: 'Password require a combination of at least 8 digits and upper and lower case letters',
    file_support: 'Support png、jpg、jpeg',
    prev_step: 'Previous',
    createSucces_tip1: '企业申请成功',
    createSucces_tip2: '请耐心等待与您联系',
    createSucces_tip3: '退出',
  },
  tw: {
    register_title: '萬店掌',
    register: '註冊',
    registernewgroup_title: '企業申請使用',
    registernewgroup_title1: '企業',
    registernewgroup_title2: '申請使用',
    addhasgroup: '加入已有企業',
    username: '用戶名',
    password: '密碼',
    showname: '姓名',
    email: '郵箱',
    mobilephone: '手機號碼',
    validatecode: '驗證碼',
    getvalidatecode: '獲取驗證碼',
    wait: '等待',
    second: '秒',
    groupname: '企業名稱',
    createenterprise: '創建企業',
    invationcode: '企業邀請碼',
    next: '下一步',
    crateenterpriseaccount: '創建企業帳號',
    inputusername: '請輸入用戶名',
    inputpassword: '請輸入密碼',
    passwordcannotsoeasy: '哦吆,密碼不能這麼隨便',
    passwordatleastsix: '密碼至少为8位数字和大小写字母组合',
    passwordmax:'密码最多50位',
    passordneednumandabc: '密碼只能是數字和字母',
    inputshowname: '請輸入姓名',
    inputmobilephone: '請輸入手機號碼',
    inputemail: '请输入邮箱',
    mobilephonenotvalid: '手機號碼不符合格式',
    emailnotvalid: '郵箱不符合格式',
    inputvalidatecode: '請輸入驗證碼',
    inputenterprisename: '請輸入企業名稱',
    creatingwait: '正在創建,請稍候……',
    infoperfect: '信息不完善',
    usernamehasexisted: '用戶名已存在',
    mobilephonehasexisted: '手機號碼已存在',
    enterprisenamehasexisted: '企業名已經存在',
    validatecodeerror: '驗證碼錯誤',
    registerfailed: '啊噢,註冊失敗!',
    serverexception: '服務器出現異常',
    can: '此用戶名可以註冊',
    cannot: '此用戶名已被註冊',
    validatecodesendsuccess: '驗證碼發送成功',
    mobilephonehasregisted: '該手機號碼已被註冊過',
    validatecodesendfailed: '驗證碼發送失敗',
    inputinvationcode: '請輸入邀請碼',
    invationcodeerror: '邀請碼錯誤',
    netspaceopen: '請點擊右上角在瀏覽器中打開',
    enterprisename: '企業名：',
    invitationuser: '推薦人：',
    joingroup: '加入企業',
    createnewgroup: '創建新企業',
    beacuse: '由於',
    passfailed: ',導致審核失敗',
    beacusesome: '由於某些原因,導致審核失敗',
    enterprisecannotnull: '企業不能為空',
    joingroupingwait: '正在加入企業,請稍候……',
    congratulations: '恭喜您,加入企業成功！',
    joingroupfailed: '啊噢,加入企業失敗！',
    uploadcertificate: '請上傳企業營業執照',
    passingwait: '您的企業營業執照正在審核中，請耐心等待',
    call400: '如需緊急處理，請撥打400-666-3626',
    reuploadcertificate: '您的企業營業執照審核不通過，請重新上傳',
    call4001: '如有任何疑問，請撥打400-666-3626',
    certificate: '營業執照',
    support: '支持',
    upload: '上傳',
    changeotheraccount: '返回',
    picnotbigthan5m: '圖片大小不能超過5M',
    uploadcannotmorethan: '上傳的圖片最多不能超過',
    zhang: '張',
    duozhang: '多張:',
    compressfailed: '壓縮失敗...',
    compresscomplete: '壓縮完成...',
    browsernotsupport: '瀏覽器不支持',
    deletecertificatesuccess: '刪除企業營業執照成功',
    deletecertificatefailed: '刪除企業營業執照失敗',
    nonewpicupload: '沒有新的圖片需要上傳',
    uploadingwait: '正在上傳請稍候……',
    uploadcertificatesuccess: '上傳營業執照成功',
    uploadcertificatefailed: '上傳營業執照失敗',
    notsupport: '暫不支持',
    imgcode: '圖片驗證碼',
    imgcodeerror: '請輸入4位的圖片驗證碼',
    inputimgcodeerror: '圖片驗證碼錯誤',
    jointip: '注：企業邀請碼可以向企業管理員進行索取',
    jointip2: '誰是我們企業管理員?',
    calltip: '請直接致電查詢',
    method1: '方法一',
    method2: '方法二',
    method2tip:
      '留下您的手機號碼和姓名信息，我們會盡快通知企業管理員與您聯繫。',
    submit: '提交',
    submitsuccess: '提交成功',
    submitfailed: '提交失敗',
    doing: '正在處理...',
    newgroup: '新企業',
    hasgroup: '已有企業',
    join: '加入',
    nochina: '用户名不能包含中文',
    validatecodesendLimit: '今日發送驗證碼數量超出限制',
    experience: "體驗",
    prodemo: "產品Demo",
    weak: '弱',
    middle: '中',
    high: '強',
    pwderrortip:'密码存在连续字母或数字（3位及以上）',
    pwdTip: '密碼至少為8位大小寫字母和數字組合',
    file_support: '支持png、jpg、jpeg',
    prev_step: '上一步',
    createSucces_tip1: '企業申請成功',
    createSucces_tip2: '請耐心等待與您聯繫',
    createSucces_tip3: '退出',
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/i18n.js
// module id = 301
// module chunks = 5